export default __webpack_public_path__ + "static/media/download.d6ff4f29.svg";